import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getServiceFollowUps = (paginate) => {
  if (!paginate) {
    return http.get(
      `${getBaseUrl()}/service_follow_up`
    );
  }
  return http.get(
    `${getBaseUrl()}/service_follow_up?${paginate}`
  );
};

export const updateServiceFollowUp = data => {
  return http.put(
    `${getBaseUrl()}/service_follow_up/${data.id}`,
    data
  );
};
